<template>
    <b-form-group v-if="visible" :label-cols-sm="labelColsSm" :label-cols-lg="labelColsLg" :description="description" :label-for="id" label-class="fs-14 grey-color fw-700 align-items-baseline" :label-align="labelRight ? 'right' : 'left'" :class="compact ? 'mb-0' : ''">
        <template #label>
            {{ label }}:
            <span v-if="!!hint" class="atmo-help">
                &nbsp;<i class="atmo-icon-question-mark"></i><span class="atmo-help__text">{{ hint }}</span>
            </span>
        </template>
        <p :id="id" class="fs-14 grey-color my-auto col-form-label" :class="valueClass + (textWrap ? ' wrap-text' : '')">{{ value ?? '&mdash;' }}</p>
    </b-form-group>
</template>

<script>
export default {
    name: 'text-row',
    props: {
        label: {
            type: String,
            required: true
        },
        value: {},
        description: {
            type: String,
            default: ''
        },
        compact: {
            type: Boolean,
            default: false
        },
        labelColsLg: {
            type: Number,
            default: 3
        },
        labelColsSm: {
            type: Number,
            default: 4
        },
        valueClass: {
            type: String,
            default: ''
        },
        forceShow: {
            type: Boolean,
            default: false
        },
        labelRight: {
            type: Boolean,
            default: false
        },
        hint: {
            type: String,
            default: ''
        },
        textWrap: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        id() {
            return 'text_row_' + this._uid;
        },
        visible() {
            return this.forceShow || this.value;
        }
    }
};
</script>

<style scoped>
.form-row {
    margin-left: 0;
    margin-right: 0;
}
.wrap-text {
    white-space: pre-wrap;
}
</style>
<style>
.form-row > .col > .text-muted {
    margin-top: 0;
    font-size: 12px;
    font-style: italic;
}
</style>
